'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _constants = require('../constants');

var _initialState = require('./initialState');

var _initialState2 = _interopRequireDefault(_initialState);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.fileCategories;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload;

  switch (type) {
    case _constants.ActionTypes.GET_FILE_CATEGORIES_SUCCESS:
      // TODO: Replace fake structure with real data from API, when it's ready
      var result = [{
        id: 'additionalFiles',
        title: 'Additional files',
        categories: payload.map(function (category) {
          return _extends({}, category, {
            limit: 10
          });
        })
      }, {
        id: 'photoFilesCategory',
        title: 'Photo files',
        categories: [{
          fileType: 'IMAGE',
          id: 'photoFiles',
          title: '',
          type: '',
          limit: 50
        }]
      }, {
        id: 'videoFilesCategory',
        title: 'Video files',
        categories: [{
          fileType: 'VIDEO',
          id: 'videoFiles',
          title: '',
          type: '',
          limit: 5
        }]
      }];
      return result;

    default:
      return state;
  }
};